import axios from 'axios';

const BASE = process.env.REACT_APP_BACKEND_URL;
const API = `${BASE}/api/tienda/admin`;

export const adminApi = {
  productos: () => axios.get(`${API}/productos`),
  producto: (id) => axios.get(`${API}/productos/${id}`),
  crear: (datos) => axios.post(`${API}/productos`, datos),
  guardar: (id, datos) => axios.put(`${API}/productos/${id}`, datos),
  visibilidad: (id, visible) => axios.put(`${API}/productos/${id}/visibilidad`, { visible }),
  subirImagen: (blob, nombre) => {
    const form = new FormData();
    form.append('archivo', blob, nombre);
    return axios.post(`${API}/imagenes`, form);
  },
  ajustes: () => axios.get(`${API}/ajustes`),
  guardarAjustes: (datos) => axios.put(`${API}/ajustes`, datos),
};

export const imgSrc = (url) => (url && url.startsWith('/api/') ? `${BASE}${url}` : url);

export const cop = (valor) => `$${Math.round(valor || 0).toLocaleString('es-CO')}`;

export const errorApi = (e, porDefecto) => {
  const detalle = e?.response?.data?.detail;
  if (typeof detalle === 'string') return detalle;
  if (Array.isArray(detalle)) return 'Revisa los campos: hay datos incompletos o demasiado largos';
  return porDefecto;
};

const uid = () => (window.crypto?.randomUUID ? window.crypto.randomUUID() : `${Date.now()}-${Math.random()}`);

export const claveDe = (x) => x.id || x._key;

export const nuevoGrupo = () => ({
  _key: uid(), nombre: '', tipo: 'unica', obligatorio: true, activo: true, ayuda: '',
  max_caracteres: 3, solo_letras: true, mayusculas: true, opciones: [],
  bordado: false, ubicaciones: [], colores_hilo: [],
});

export const UBICACIONES_BORDADO = [{ id: 'pecho', titulo: 'Pecho izquierdo' }, { id: 'puno', titulo: 'Puño izquierdo' }];

export const COLORES_HILO = [
  { nombre: 'Azul marino', hex: '#1F2A44' }, { nombre: 'Negro', hex: '#1A1A1A' }, { nombre: 'Blanco', hex: '#F4F1EA' },
  { nombre: 'Dorado', hex: '#B8925A' }, { nombre: 'Vinotinto', hex: '#6B1F2E' }, { nombre: 'Gris plata', hex: '#A3A7AD' },
];

export const nuevaOpcion = () => ({ _key: uid(), titulo: '', imagen_url: null, especificaciones: '', activo: true });

export const nuevoEnvio = () => ({ _key: uid(), titulo: '', descripcion: '', costo: '', pide_direccion: false, activo: true });

export const mover = (lista, i, delta) => {
  const j = i + delta;
  if (j < 0 || j >= lista.length) return lista;
  const copia = [...lista];
  [copia[i], copia[j]] = [copia[j], copia[i]];
  return copia;
};

export const TIPOS_GRUPO = [
  { valor: 'unica', etiqueta: 'Una sola opción' },
  { valor: 'multiple', etiqueta: 'Varias opciones' },
  { valor: 'texto', etiqueta: 'Texto' },
];

export const errorProducto = (p) => {
  if ((p.nombre || '').trim().length < 2) return 'Escribe el nombre del producto';
  if (!(Number(p.precio) > 0)) return 'Escribe un precio mayor a cero';
  const grupo = p.grupos.find(g => !g.nombre.trim());
  if (grupo) return 'Todos los grupos de opciones necesitan un nombre';
  const conOpcionVacia = p.grupos.find(g => g.tipo !== 'texto' && g.opciones.some(o => !o.titulo.trim()));
  if (conOpcionVacia) return `Todas las opciones de «${conOpcionVacia.nombre}» necesitan un título`;
  const bordado = p.grupos.find(g => g.tipo === 'texto' && g.bordado && (g.colores_hilo || []).some(c => !c.nombre.trim()));
  if (bordado) return `Todos los colores de hilo de «${bordado.nombre}» necesitan un nombre`;
  const repetido = p.grupos.find(g => g.tipo === 'texto' && g.bordado
    && new Set((g.colores_hilo || []).map(c => c.nombre.trim().toLowerCase())).size !== (g.colores_hilo || []).length);
  if (repetido) return `Hay colores de hilo con el mismo nombre en «${repetido.nombre}»`;
  return null;
};
